import { Component, Mixins, Watch } from 'vue-property-decorator';
import { MagicConfigMixin } from '@gig/magic-common';
import { notificationService, NotificationDelay } from '@gig/magic-messaging';

import { magic } from '@gig/magic-sdk';

import { RouteName } from '../../routes/routes.constants';
import { Country } from '@gig/magic-sdk/dist/adapter/users/getCountries';
import {
    ACCOUNT_IS_PROCESSING_STATUS_QUERY,
    ACCOUNT_REQUIRES_VERIFICATION_UPDATED,
} from '@gig/magic-messages';
import { ISubscription } from '@gig/magic-message-bus/dist/base-bus';

@Component({
    name: 'block-manager',
})
export default class BlockManagerComponent extends Mixins(MagicConfigMixin) {
    private blockStatusSubscription: ISubscription | null = null;

    render() {
        return null;
    }

    @Watch('$route.name')
    onRouteChange() {
        if (this.$route.name !== null && !this.blockStatusSubscription) {
            this.initBlockStatusSubscription();
        }
    }

    routeUser(country: Country | undefined) {
        switch (country) {
            case Country.NETHERLANDS:
            case Country.ARGENTINA:
            case Country.ROMANIA:
                if (this.$route.name !== RouteName.USER_VERIFICATION) {
                    this.$router.push({
                        name: RouteName.USER_VERIFICATION,
                    });
                }
                break;
            default:
                if (this.$route.name !== RouteName.VERIFICATION) {
                    this.$router.push({
                        name: RouteName.VERIFICATION,
                    });
                }
        }
    }

    async initBlockStatusSubscription() {
        this.blockStatusSubscription = window.eventBus.subscribe<boolean>(
            ACCOUNT_REQUIRES_VERIFICATION_UPDATED,
            async (e) => {
                if (!e.payload) {
                    return;
                }
                const user = magic.session.getUser();

                this.routeUser(user?.country);

                const isProcessing = await window.queryBus.query<boolean>(
                    ACCOUNT_IS_PROCESSING_STATUS_QUERY,
                );

                if (isProcessing) {
                    notificationService.show(
                        this.$t('verification.notification.pending'),
                        {
                            closeDelay: NotificationDelay.LONG,
                            uniqueID: 'verification-notification-pending',
                        },
                    );
                    return;
                }

                notificationService.show(
                    this.$t('verification.notification.required'),
                    {
                        closeDelay: NotificationDelay.LONG,
                        uniqueID: 'verification-notification-required',
                    },
                );
            },
            { distinct: true },
        );
    }

    destroyed() {
        this.blockStatusSubscription?.unsubscribe();
    }
}
